"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discounts = void 0;
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const react_1 = __importDefault(require("react"));
const Heading_1 = require("../../heading/Heading");
const Label_1 = require("../../input/label/Label");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const helpers_1 = require("../../../../entities/pricing/helpers");
const index_1 = require("../../../../index");
const fullStory_1 = require("../../../../util/fullStory");
const Discounts = ({ defaults, setDefaults }) => {
    var _a, _b;
    const sevenNightDiscount = defaults.discounts.find((d) => d.nights === 7);
    const sevenNightDiscountAmount = (0, helpers_1.factorDiscountToPercentage)((_a = sevenNightDiscount === null || sevenNightDiscount === void 0 ? void 0 : sevenNightDiscount.factor) !== null && _a !== void 0 ? _a : helpers_1.NO_DISCOUNT_FACTOR);
    const twentyEightNightDiscount = defaults.discounts.find((d) => d.nights === 28);
    const twentyEightNightDiscountAmount = (0, helpers_1.factorDiscountToPercentage)((_b = twentyEightNightDiscount === null || twentyEightNightDiscount === void 0 ? void 0 : twentyEightNightDiscount.factor) !== null && _b !== void 0 ? _b : helpers_1.NO_DISCOUNT_FACTOR);
    const updateDiscounts = (numNights, newDiscountAmount) => {
        const restOfDiscounts = defaults.discounts.filter((d) => d.nights !== numNights);
        setDefaults(Object.assign(Object.assign({}, defaults), { discounts: [
                ...restOfDiscounts,
                { nights: numNights, factor: (0, helpers_1.percentageDiscountToFactor)(newDiscountAmount) }
            ] }));
    };
    const { propertyId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_discounts_modal_viewed', { property_id: propertyId });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading_1.HeadingSmall, null, "Discounts"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null, "Do you want to offer any discounts for long stays?"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
        react_1.default.createElement(Label_1.Label, { htmlFor: "seven-night-discount" }, "7 night discount"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
        react_1.default.createElement(merlin_input_stepper_1.InputStepper, { id: "seven-night-discount", onClick: (value) => updateDiscounts(7, value), minValue: 0, maxValue: 100, value: sevenNightDiscountAmount, valueFormatter: (n) => `${n}% discount` }),
        react_1.default.createElement(Spacer_1.Spacer, null),
        react_1.default.createElement(Label_1.Label, { htmlFor: "twenty-eight-night-discount" }, "28 night discount"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
        react_1.default.createElement(merlin_input_stepper_1.InputStepper, { id: "twenty-eight-night-discount", onClick: (value) => updateDiscounts(28, value), minValue: 0, maxValue: 100, value: twentyEightNightDiscountAmount, valueFormatter: (n) => `${n}% discount` })));
};
exports.Discounts = Discounts;
//# sourceMappingURL=Discounts.js.map